import React, { useCallback } from "react";
import "../../index.css";

const Button = React.memo(({ label, type, onClick }) => {
  const handleClick = useCallback(() => {
    if (onClick) {
      onClick();
    }
  }, [onClick]);

  return (
    <button
      type={type}      className="px-6 py-2 bg-gradient-to-r from-[#686bff] to-[#00b812] text-white rounded-lg text-lg font-bold duration-200 transform hover:rounded-full hover:-translate-y-1 transition"
      onClick={handleClick}
    >
      {label}
    </button>
  );
});

export default Button;
